import { render, staticRenderFns } from "./ManageVidvie.vue?vue&type=template&id=67780e09&scoped=true"
import script from "./ManageVidvie.vue?vue&type=script&lang=js"
export * from "./ManageVidvie.vue?vue&type=script&lang=js"
import style0 from "./ManageVidvie.vue?vue&type=style&index=0&id=67780e09&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67780e09",
  null
  
)

export default component.exports